module.exports = __webpack_public_path__ + "static/img/banner-3.3af17f82.png";